<template>
  <div class="dashboard__container">
    <div class="dashboard__container--body" v-if="user">
      <div class="dashboard__container--body--col">
        
        <ProfileContact :user="user" :currentUser="currentUser" />
        <ProfileAddress :user="user" class="mb-5" />
        
      </div>
      <div class="dashboard__container--body--col">

        

        <ProfileOnboard :user="user" :userContractorPayProfile="userContractorPayProfile" class="mb-5" />

        <ProfileEmployeeOnboard :user="user" :userEmployeePayProfile="userEmployeePayProfile" class="mb-5" />

        <div class="whiteBack mb-5">
          <h4>ABM / Beeline Status</h4>
          <div class="mb-3">
            <label for="beelline">Added to Beeline:</label>
            <input type="checkbox" v-model="user.beeline" id="beelline" class="ml-3" @change="updateUser()" />
          </div>
        </div>
        <div class="whiteBack mb-5" v-if="user.leadApplicationSubmitted">
          <h4>Lead Application</h4>
          
          <label for="appstatus" class="pb-2">Update Status</label>
          <v-select
            label="title" 
            :options="statuses"
            v-model="user.leadStatus"
            @input="updateStatus()"
            :clearable="false"
            >
          </v-select>
          <div class="caption mt-3">
            <div>What areas? {{user.leadApplication.areas}}</div>
            <div>Pass background check? {{user.leadApplication.background}}</div>
            <div>Highest level of education: {{user.leadApplication.education}}</div>
            <div>Comfortable speaking english? {{user.leadApplication.english}}</div>
            <div>Other Languages {{user.leadApplication.languages}}</div>
            <div>Hours per week: {{user.leadApplication.hours}}</div>
            <div>Some Nights and Weekend: {{user.leadApplication.nightsWeekends}}</div>
            <div>Tech Savvy: {{user.leadApplication.tech}}</div>
            <div>Do they have a car: {{user.leadApplication.transportation}}</div>
            <div>Comfortable walking/standing? {{user.leadApplication.walk}}</div>
            <div v-if="user.leadApplication.leadingExperience">Experinence Leading Teams: {{user.leadApplication.leadingExperience}}</div>
            <div v-if="user.leadApplication.clients">Times they've worked directly with clients: {{user.leadApplication.clients}}</div>
            <div v-if="user.leadApplication.anythingElse">Anything else: {{user.leadApplication.anythingElse}}</div>
          </div>
        </div>

        <ProfileBackground :user="user" class="mb-5" />
        <!-- <ProfileSkills :user="user" /> -->
        <!-- <ProfileId :user="user" /> -->
        <!-- <ProfileTags :user="user" :userProfile="userProfile" /> -->
        <!-- <ProfileCerts :user="user" /> -->
        <ProfileBlacklist :user="user" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StarRating from 'vue-star-rating'
import Loader from '@/components/Loader.vue'
import ProfileContact from '@/components/Profile/ProfileContact.vue'
import ProfileAddress from '@/components/Profile/ProfileAddress.vue'
import ProfileEmployeeOnboard from '@/components/Profile/ProfileEmployeeOnboard.vue'
import ProfileOnboard from '@/components/Profile/ProfileOnboard.vue'
import ProfileBackground from '@/components/Profile/ProfileBackground.vue'
import ProfileBlacklist from '@/components/Profile/ProfileBlacklist.vue'
import Rewards from '@/components/Rewards.vue'
import router from '@/router'
const fb = require('../../firebaseConfig.js')

export default {
  props: ['user', 'dnr'],
  name: 'userDetails',
  data: () => ({
    statuses: ['New', 'In Review', 'Hired', 'On-Hold', 'Not Hired', 'Hide/Duplicate'],
  }),
  computed: {
    ...mapState(['currentUser', 'userInfo', 'userProfile', 'userVerifications', 'userContractorPayProfile', 'userEmployeePayProfile']),
    // docHeld() {
    //   if (this.user && this.user.docHold) {
    //     return true
    //   }
    // },
    // dnr() {
    //  if (this.user && this.user.blacklist && this.user.blacklist.length >= 1) {
    //   return true
    //  }
    // }
    // joined() {
    //   if(this.user && this.user.created) {
    //     return new Date(this.user.created.seconds*1000)
    //     console.log(this.currentUser.metaData)
    //   }
    // }
  },
  components: {
    Loader,
    StarRating,
    ProfileContact,
    ProfileAddress,
    ProfileOnboard,
    ProfileEmployeeOnboard,
    ProfileBackground,
    ProfileBlacklist,
   
    // UserNote,
    // NotesTable,
    // UserReview,
    // ReviewsTable,
    
    // ProfileMessage,
    // MessageTable,
    Rewards,
  },
  methods: {
    async updateStatus() {
      await fb.leadApplicationsCollection.doc(this.user.leadApplicationId).update({
        status: this.user.leadApplicationStatus
      })
      this.updateUser()
    },
    updateUser() {
      fb.usersCollection.doc(this.user.id).update(this.user)
    },
  },
  beforeDestroy() {
    this.statuses = null
    delete this.statuses
    delete this.updateUser
    delete this.updateStatus
  }
}

</script>